
export default function backToTop(threshold = 200) {
  const scrollBtn = document.querySelector('#backtotop');
  if (!scrollBtn) return;

  let ticking = false;

  function toggleVisibility() {
    if (window.scrollY >= threshold) {
      scrollBtn.classList.add('show');
    } else {
      scrollBtn.classList.remove('show');
    }
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        toggleVisibility();
        ticking = false;
      });
      ticking = true;
    }
  });

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
